<div class="loader-overlay" *ngIf="IsLoadingData">
    <div class="loader-overlay-box">
        <span class="fa fa-spinner fa-spin"></span>
    </div>
</div>
<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons
            class="eotp-update-toolbar"
            [ContextMenuItems]="modelData.MainList.TableContextMenuItems"
            [actionService]="actionService"
            [ContextMenuIndicator]="'eotpremnica'"
        >
            <!-- <div style="width: 42%; text-align: left; margin-left: 2%;"> -->
            <div class="eotp-toolbar-title">
                <h2 style="display: inline-block; color: #71b1d1;">
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'eotpremnice/izeotpremnica'"><span
                            translate="EOTPREMNICA.NEW.IZOTPREMNICA"></span></span>
                    <span *ngIf="baseUpdate.Item.ID <= 0 && formControlDataName == 'eotpremnice/uleotpremnica'"><span
                            translate="EOTPREMNICA.NEW.ULOTPREMNICA"></span></span>

                    <span *ngIf="baseUpdate.Item.ID > 0">
                        <span *ngIf="formControlDataName == 'eotpremnice/izeotpremnica'"><span
                                translate="EOTPREMNICA.EDIT.IZOTPREMNICA"></span></span>
                        <span *ngIf="formControlDataName == 'eotpremnice/uleotpremnica'"><span
                                translate="EOTPREMNICA.EDIT.ULOTPREMNICA"></span></span>
                        <span style="padding-left: 5px">{{baseUpdate.Item.BrojOtpremnice}}</span>
                    </span>
                </h2>
            </div>

            <!-- <div style="padding-left: 5px; margin-right: 25px; margin-top: 10px;color: #71b1d1;"> -->
            <div class="eotp-toolbar-text" style="color: #71b1d1;">
                <span *ngIf="nazivStatusa"
                        text-align="center"                         
                        [translate]="nazivStatusa">
                </span>
            </div>

            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eotpremnice/izeotpremnica'">
                <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'EOTPREMNICA.SEND.ACTION'"
                    [Container]="'body'" (clicked)="SendEDespatch(baseUpdate.Item)"
                    [IsDisabled]="baseUpdate.Item.ID==-1 || loadingSendEDespatch || !baseUpdate.Item.Editable || baseUpdate.Item.StatusGenericName != null"
                    [Model]="'izeotpremnica'" [Action]="'Upload_XML_Sef_EOtpremnica'">
                    <i class="fas fa-file-export"></i>
                    <span *ngIf="loadingSendEDespatch" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                </yt-button>
            </div>
            <div class="btn-group mr-1">
                <yt-button [Class]="'btn btn-outline-primary'" [NgbTooltip]="'EOTPREMNICA.OSVEZISTATUS.ACTION'"
                    [NgStyle]="{'background-color':bojaStatusa}" [Container]="'body'" (clicked)="RefreshStatusClick()"
                    [Model]="'izeotpremnica'" [Action]="'Upload_XML_Sef_EOtpremnica'">
                    <i class="fas fa-sync-alt"></i>
                    <span *ngIf="loadingEUDespatchStatus" class="loader"><span
                            class="fa fa-spinner fa-spin"></span></span>
                </yt-button>
            </div>
            
            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eotpremnice/uleotpremnica'">
                <button class="btn btn-outline-primary" ngbTooltip="{{'EOTPREMNICA.FIZICKIPRIJEM.ACTION' | translate}}"
                    container="body" (click)="FizickiPrijem(baseUpdate.Item.ID)"
                    [disabled]="baseUpdate.Item.ID==-1 || baseUpdate.Item.StatusGenericName !== 'Received'"
                    >
                    <i class="fas fa-solid fa-check"></i>
                    <span style="padding-left: 5px;" translate="EOTPREMNICA.FIZICKIPRIJEM.SINGULAR"></span>
                </button>
            </div>

            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eotpremnice/uleotpremnica'">
                <button class="btn btn-outline-primary" ngbTooltip="{{'EOTPREMNICA.KREIRAJPRIJEMNICU.ACTION' | translate}}"
                    container="body" (click)="KreirajPrijemnicu(baseUpdate.Item.ID)"
                    [disabled]="baseUpdate.Item.ID==-1 || baseUpdate.Item.StatusGenericName !== 'DeliveryConfirmed'"
                    >
                    <i class="fas fa-file-alt"></i>
                    <span style="padding-left: 5px;" translate="EOTPREMNICA.KREIRAJPRIJEMNICU.SINGULAR"></span>
                </button>
            </div>

            <!-- Ubaciti deo da se vidi broj prijemnice na masci za ulaznu otpremnicu -->
             <!-- <div style="padding-left: 5px; margin-right: 25px; margin-top: 10px;color: #71b1d1;">
                <span *ngIf="baseUpdate.Item?.BrojIzlaznePrijemnice"
                        text-align="center"                         
                        style="padding-left: 2px">
                        {{baseUpdate.Item.BrojIzlaznePrijemnice}}
                </span>
            </div> -->
                                        <!-- margin-top: 10px; -->
                    <div *ngIf="brojPrijemnice" class="eotp-toolbar-receipt-no">
                    <!-- <div *ngIf="brojPrijemnice"
                        style="
                            padding-left: 5px;
                            margin-right: 25px;
                            color: #71b1d1;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            text-align: center;
                            line-height: 1.2;
                        "
                        > -->
                        <span style="font-size: 12px;"
                        translate="EOTPREMNICA.BROJIZLAZNEPRIJEMNICE.SINGULAR">
                            
                        </span>

                        <span style="font-size: 16px; font-weight: 600; padding-top: 2px;">
                            {{brojPrijemnice}}
                        </span>
                        </div>


            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eotpremnice/uleotpremnica'">
                <button type="button"
                    [disabled]="baseUpdate.Item.ID==-1"
                    (click)="PrintPDF()"
                    class="btn btn-primary"
                    ngbTooltip="{{'EOTPREMNICA.PRINTPDF.ACTION' | translate}}"
                    container="body">
                    <span class="fa fa-fw fa-print"></span>
                </button>
            </div>
            <div class="btn-group mr-1" *ngIf="formControlDataName == 'eotpremnice/uleotpremnica'">
                <button type="button"
                    [disabled]="baseUpdate.Item.ID==-1"
                    (click)="PreuzmiPriloge()"
                    class="btn btn-primary"
                    ngbTooltip="{{'EOTPREMNICA.PREUZMIPRILOGE.ACTION' | translate}}"
                    container="body">
                    <span class="fa fa-solid fa-download"></span>
                </button>
            </div>
           
        </yt-fw-default-update-buttons>
    </div>
</div>
<yt-eotpremnica-update #baseUpdate></yt-eotpremnica-update>